import { Dropdown, Menu } from 'antd'
import logoImage from '../assets/images/logo/logofull-bright.png'
import logoSmallImage from '../assets/images/logo/logosmall.png'
import { Icon } from '@iconify/react'
import { useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import axiosInstance from './lib/axiosInstance'
import { AuthData, HttpResponse, User } from './commons'

const Navbar = () => {
  const navigate = useNavigate()

  const [token, setToken] = useState('')
  const [user, setUser] = useState<User>()

  useEffect(() => {

    const getUserFromCacheOrApi = (userId: string) => {
      const cachedUser = localStorage.getItem('user')
            
      if (cachedUser) {
        setUser(JSON.parse(cachedUser));
      }
      else {
        axiosInstance.get<any, HttpResponse<User>>(`/api/v1/Users/ViewById?Id=${userId}`)
        .then(response => {
          if (response.data && response.data.status && response.data.data) {
            localStorage.setItem('user', JSON.stringify(response.data.data))
            setUser(response.data.data)
          }
          else {
            console.error('Error fetching user data:', response)
          }
        })
        .catch(console.log)
      }
    }

    const authData = localStorage.getItem('auth')
    if (authData) {
      const { token, userId } = JSON.parse(authData) as AuthData
      setToken(token)
      getUserFromCacheOrApi(userId)
    }
  }, [])

  const formatUser = (user: User | null) => {
    if (!user) return 'N/A'
    return (
      <span>
        <span style={{ color: 'black' }}>
          {user.firstName} {user.lastName}
        </span>
        <span className="text-blue-900"> ({user.roleName})</span>
      </span>
    )
  }

  const handleMenuClick = (e: any) => {
    if (e.key === 'logout') {
      localStorage.clear()
      navigate('/login')
    }
  }

  const userMenu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key="logout">
        <div className="flex items-center">
        <svg
            width="100%"
            height="100%"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="w-4 h-4 mr-2"
          >
            <path
              d="M16 17L21 12M21 12L16 7M21 12H9M9 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H9"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span>Logout</span>
        </div>
      </Menu.Item>
    </Menu>
  )

  return token ? (
    <div>
      <div className="hidden md:block bg-gray-100 md:bg-white w-full px-20 text-text-black">
        <div className="w-full px-4 mx-auto">
          <div className="flex flex-wrap -mx-4">
            <div className="flex-1 basis-0 max-w-full">
              <div className="flex justify-between items-center w-full">
                <div className="flex items-center md:h-20">
                  <img src={logoImage} alt="User Avatar" className="w-50 h-10 cursor-pointer" />
                </div>
                <Dropdown overlay={userMenu} trigger={['click']}>
                  <div className="cursor-pointer flex gap-2.5 items-center">
                    {user && <div className="mr-2">Hi, {formatUser(user)}</div>}
                    <Icon icon="mingcute:down-fill" />
                  </div>
                </Dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex md:hidden items-center justify-between w-full px-6 py-2">
      <img src={logoSmallImage} alt="User Avatar" className="w-50 h-10 cursor-pointer" />

        <Dropdown overlay={userMenu} trigger={['click']}>
          <div className="flex items-center cursor-pointer">
            {user && <div className="mr-2 text-xs">Hi, {formatUser(user)}</div>}
            <Icon icon="mingcute:down-fill" />
          </div>
        </Dropdown>
      </div>
    </div>
  ) : null
}

export default Navbar
